import type { ShippingApi } from '@/pages/Business/pages/Shippings/models';

const DRAFT_KEY = 'amendments_draft';

export type AmendmentDraft = Record<string, unknown>;

const read = (): AmendmentDraft => {
  try { return JSON.parse(localStorage.getItem(DRAFT_KEY) ?? 'null') ?? {}; }
  catch { return {}; }
};

const write = (data: AmendmentDraft) => {
  try { localStorage.setItem(DRAFT_KEY, JSON.stringify(data)); }
  catch {}
};

export const useAmendmentStorage = () => {
  const draft = read();

  const updateDraft = (patch: AmendmentDraft) => {
    write({ ...read(), ...patch });
  };

  const clearDraft = () => {
    localStorage.removeItem(DRAFT_KEY);
  };

  const setShipping = (shipping: ShippingApi | null) => {
    if (!shipping) {
      clearDraft();
      return;
    }
    const current = read();
    const isNewShipping =
      String((current.shipping as ShippingApi | undefined)?.number) !== String(shipping.number);
    write(isNewShipping ? { shipping } : { ...current, shipping });
  };

  return { draft, updateDraft, clearDraft, setShipping };
};
